export function dateInputValueToDate(value: string): Date | undefined {
  if (!value) return undefined
  return new Date(`${value}T00:00:00`)
}

export function dateToDateInputValue(date: Date | undefined): string {
  if (!date) return ''

  const year = date.getFullYear()
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const day = String(date.getDate()).padStart(2, '0')

  return `${year}-${month}-${day}`
}
